if (!customElements.get('article-slider')) {
  class ArticleSlider extends HTMLElement {
    static selectors = {
      arrows: {
        left: '.arrow-left',
        right: '.arrow-right',
      },
      slider: '.swiper',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderElement = this.querySelector(ArticleSlider.selectors.slider);

      this.settings = {
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        spaceBetween: 20,
        navigation: {
          prevEl: this.querySelector(ArticleSlider.selectors.arrows.left),
          nextEl: this.querySelector(ArticleSlider.selectors.arrows.right),
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 21,
          },
        },
      };

      this.slider = new Swiper(this.sliderElement, this.settings);
    }
  }

  customElements.define('article-slider', ArticleSlider);
}
